document.addEventListener("DOMContentLoaded", function () {
    // Loop through each order row
    document.querySelectorAll(".deliver__status").forEach(async (statusCell) => {
      const orderId = statusCell.getAttribute("data-order-id");
  
      try {
        // Call orderStatus API
        const statusResponse = await fetch(`https://zuup.marmeto.com/api/unicommerce/orderStatus?code=${orderId}`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json"
          },
          body: ""
        });
  
        if (!statusResponse.ok) throw new Error("Failed to fetch order status");
  
        const statusData = await statusResponse.json(); 
        const orderStatus = statusData.data.status;
        const canDownloadInvoice = statusData.data.canDownloadInvoice;  
        // const lineItemCancelButton = document.querySelectorAll('#cancel-line-item');
  
        // Show the status in the <td>
        statusCell.textContent = orderStatus.charAt(0).toUpperCase() + orderStatus.slice(1).toLowerCase();

        // const orderStatusSmall = orderStatus.toLowerCase();

        // if (orderStatusSmall == 'dispatched') {
        //   lineItemCancelButton.forEach((cancelButton) => {
        //     cancelButton.style.display == 'none';
        //   })
        // }
        
  
        // Show invoice button only if delivered and canDownloadInvoice is true
        if (orderStatus === "DELIVERED" && canDownloadInvoice === true) {
          const invoiceBtn = document.querySelector(`.download-invoice-btn[data-order-id="${orderId}"]`);
          if (invoiceBtn) {
            invoiceBtn.style.display = "inline-block";
          }
        }
  
      } catch (error) {
        console.error(`Error fetching status for order ${orderId}:`, error);
        statusCell.textContent = "Status unavailable";
      }
    });
  
    // Add click handler for invoice buttons
    document.querySelectorAll(".download-invoice-btn").forEach((button) => {
      button.addEventListener("click", async function () {
        const orderId = this.getAttribute("data-order-id");
        const originalText = this.innerHTML;
  
        this.innerHTML = '<span class="spinner"></span>';
        this.disabled = true;
  
        try {
          const invoiceResponse = await fetch(`https://zuup.marmeto.com/api/order-invoice?orderCode=${orderId}&store=redchief`, {
            method: "GET"
          });         
  
          if (!invoiceResponse.ok) throw new Error("Failed to fetch invoice"); 
  
          const blob = await invoiceResponse.blob();
          const url = window.URL.createObjectURL(blob);
  
          const a = document.createElement("a");
          a.href = url;
          a.download = `Invoice-${orderId}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
  
        } catch (error) {
          console.error("Error downloading invoice:", error);
          alert("Unable to download invoice. Please try again later.");
        }
  
        this.innerHTML = originalText;
        this.disabled = false;
      });
    });
});
  